import { createStyles } from "@envestnet/envreact-component-library";
import type { WithStyles } from "@envestnet/envreact-component-library";

const styles = () =>
  createStyles({
    container: {
      margin: 0,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
